export default {"src":"/_next/static/media/error.bcf0395e.svg","height":16,"width":16};